<template>
	<div class="par_wrap">
		<p class="back_box" @click="back()">
			<img src="../../../static/images/back.png" alt=""> 
			<span>{{langtrans().fhssyy[languageIndex]}}</span>
		</p>
		<div class="box">
			<!-- <ParheaderVue :caseid="caseid" :token="token"/> -->
			<div class="swi_box">
				
				<div class="req_box">
					<p><b>{{langtrans().jyqq[languageIndex]}}</b></p>
					<div class="box_req">
						<p><b>{{langtrans().ajxsxx[languageIndex]}}</b></p>
						<div class="bottom_box">
							<keep-alive>
								<router-view></router-view>
							</keep-alive>
						</div>
						<ul>
							<li>
								<template v-if="acc_list.length != 0">
									<b>{{langtrans().jyqqfj[languageIndex]}} </b>
									<div class="acc_box">
					                    <attaList :attaArr="acc_list"></attaList>
									</div>										
								</template>							
								<div class="rescue_box">
									<div class="box" v-for="(v,ind) in obj2" :key="ind">
										<p v-if="v.dict&&v.dict.parentId===0"><b>{{languageIndex==0?v.dict.name : v.dict.nameEn}}{{langtrans().jyffwq[languageIndex]}}</b></p>
										<div v-if="v.dict&&v.dict.parentId===0" class="box">
											<fuwuqingdan :attaArr=obj2.slice(1,obj2.length)></fuwuqingdan>
										</div>
									</div>
									
								</div>
							</li>
						</ul>
						<div class="upbtn_box">
							<el-button type="primary" v-if="flag" @click="toinf">{{langtrans().hfbjjj[languageIndex]}}</el-button>
							<el-button type="primary" v-if="!flag" @click="back">{{langtrans().gbxqq[languageIndex]}}</el-button>
						</div>
					</div>
					<div class="textHf">
						<p>*{{langtrans().rdajjq[languageIndex]}}</p>
						<p>{{langtrans().lxjdh[languageIndex]}}+86 10 6818 0898</p>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import langtrans from "./js/par.vue.trans.js";
	import qs from "qs";
	import "isomorphic-fetch";
	import constants from "@/util/constants.js";
	import Promise from 'promise-polyfill';
	import ParheaderVue from "../par/parheader.vue";
	import attaList from "@/components/attachment/index1";
	import fuwuqingdan from "@/components/attachment/qingdan1";
	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		components: {
			ParheaderVue,
			attaList,
			fuwuqingdan
		},
		data() {
			return {
				solutionState: 0,
				token: this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data,
				caseid: this.$route.query.caseid,
				obj: {},
				victimList: {},
				casenumber: "AJ200101",
				inf: null,
				obj2: null,
				acc_list: [],
				checkList: [],
				bid: [],
				flag: true,
				typeId: this.$route.query.typeId
			};
		},
		methods: {
			langtrans(){
				return langtrans
			},				
			toinf() {
				let that = this;

				if(that.solutionState === 0) {
					that.$router.push({
						path: "/commonPage/caseindex/inf",
						name: "Inf",
						params: {
							token: this.token,
						},
						query: {
							typeId: this.$route.query.typeId,
							caseid: this.caseid
						}
					});
				}
			},
			back() {
				let that = this;
				this.$router.push({
					path: "/commonPage/caseindex/await",
					name: "Await",
					params: {
						token: that.token
					},
					query: {
						typeId: this.typeId
					}
				});
			},
			up(v) {
				console.log("par up:" + v);
			},
			getupload(solutionid) {
				let that = this;
				fetch(constants.domain + "rescue/case/upload_cnts", {
						method: "POST",
						body: `token=${this.token}&objType=1&objId=${this.caseid}&caseId=${this.caseid}`,
						mode: "cors",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					})
					.then(function(res) {
						return res.json();
					})
					.then(function(data) {
						console.log("upload_cnt:" + data);
						data.obj.map(function(v) {
							if(constants.isPic(v.url)) {
								v.icon = v.url;
							} else {
								v.icon = '../../../static/images/eles_icon.png';
							}
							that.acc_list.push(v);
						});
//						that.acc_list=that.acc_list.filter(item => {
//							return item.type == '140' && item.objType == '1'
//						})
					});
			},
			setdata() {
				let that = this;
				this.$router.push({
					name: "parinf",
					params: {
						token: this.token
					},
					query: {
						typeId: this.$route.query.typeId,
						caseid: this.caseid
					}
				});
			}
		},

		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
		mounted() {
			let that = this;
			fetch(constants.domain + "rescue/case/detail_case", {
					method: "POST",
					body: `token=${this.token}&caseId=${this.caseid}`,
					mode: "cors",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					}
				})
				.then(function(res) {
					return res.json();
				})
				.then(function(data) {
					that.init = data.obj;
					that.obj = data.obj.obj;
					that.obj2 = data.obj2;
					that.victimList = data.obj.victimList[0];
					that.flag = data.obj.solutionState == 0;
					that.setdata();
				});
			fetch(constants.domain + "rescue/bidding/bidders", {
					method: "POST",
					body: `token=${this.token}&caseId=${this.caseid}`,
					mode: "cors",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					}
				})
				.then(function(res) {
					return res.json();
				})
				.then(function(data) {
					that.bid = data.obj;
				});

			this.getupload();
		}
	};
</script>

<style scoped>
	a {
		text-decoration: none;
		color: #999;
	}
	
	.par_wrap {
		width: 100%;
	}
	
	.back_box {
		text-align: left;
		font-size: 14px;
		line-height: 45px;
		color: #666;
		cursor: pointer;
	}
	.back_box *{
		vertical-align: middle;
		height: 18px;
		line-height: 18px;
		display: inline-block;
	}
	.box {
		width: 100%;
		text-align: left;
	}
	
	.box>h2 {
		font-size: 20px;
		color: #333;
		font-weight: 600;
		line-height: 45px;
	}
	
	.box_req {
		margin-left: 68px;
		margin-top: 10px;
	}
	
	.box_req ul li b {
		font-size: 14px;
		margin-bottom: 10px;
		display: block
	}
	
	.case_box {
		width: 100%;
	}
	
	.case_box p {
		line-height: 45px;
	}
	
	.case_box p span {
		margin-left: 20px;
	}
	
	.case_box ul {
		border: 1px solid #d9ddde;
	}
	
	.case_box ul li {
		width: 39%;
		text-align: start;
		text-indent: 1em;
		font-size: 14px;
		overflow: hidden;
		height: 42px;
		display: inline-block;
		line-height: 42px;
		border-right: #d9ddde 1px solid;
		border-top: #d9ddde 1px solid;
	}
	
	.case_box ul li:nth-child(3n) {
		border-right: 0;
		width: 20%;
	}
	
	.case_box ul li:first-child,
	.case_box ul li:nth-child(2),
	.case_box ul li:nth-child(3) {
		border-top: 0;
	}
	
	.btn_box {
		color: #00abfa;
		cursor: pointer;
	}
	
	.top_box {
		width: 100%;
	}
	
	.top_box p {
		width: 260px;
		background: #f2f5f8;
		margin: 30px auto;
		height: 40px;
		text-align: center;
	}
	
	.top_box p a {
		display: inline-block;
		width: 120px;
		height: 30px;
		margin-top: 5px;
		line-height: 30px;
		text-align: center;
	}
	
	.router-link-exact-activem,
	.router-link-active {
		color: #00abfa;
		background: #fff;
	}
	
	.req_box>p {
		line-height: 45px;
		text-align: left;
		font-size: 18px;
		margin-left: 40px;
	}
	
	.box_req ul li b {
		font-size: 16px;
	}
	
	.org_box {
		font-size: 16px;
		box-sizing: border-box;
		padding-left: 15px;
	}
	
	.org_box p {
		line-height: 40px;
		color: #333;
	}
	
	.acc_box {
		box-sizing: border-box;
		padding-right:10px;
		margin-left: 30px;
	}
	
	.acc_box>p {
		color: #333;
		line-height: 40px;
		font-size: 15px;
	}
	
	.acc_box ul li {
		display: inline-block;
		width: 20%;
		text-align: center;
	}
	
	.acc_box ul li p {
		text-align: center;
		line-height: 36px;
		height: 36px;
		font-size: 14px;
	}
	
	.acc_box ul li img {
		width: 90px;
		height: 120px;
	}
	
	.acc_box ul li a {
		color: #00abfa;
		font-size: 14px;
	}
	
	.rescue_box {
		box-sizing: border-box;
	}
	
	.rescue_box>.box>p {
		line-height: 40px;
		font-size: 14px;
	}
	
	.rescue_box .box .el-checkbox-group {
		margin-left: 10px;
	}
	
	.rescue_box>.el-checkbox-group {
		margin-left: 10px;
		margin-top: 10px;
	}
	
	.rescue_box>p {
		line-height: 40px;
		font-size: 14px;
	}
	
	.res_div {
		position: relative;
		top: 18px;
	}
	
	.res_box {
		position: relative;
		top: 20px;
		font-size: 14px;
		color: #999;
	}
	
	.el-checkbox-group {
		position: relative;
		box-sizing: border-box;
		padding: 0 15px;
	}
	
	.el-checkbox {
		width: 100%;
		margin-bottom: 20px;
	}
	
	.el-checkbox+.el-checkbox {
		margin-left: 0;
	}
	
	.db_div,
	.res_div {
		font-size: 14px;
		color: #333;
	}
	
	.db_box {
		font-size: 14px;
		color: #333;
		margin-left: 30px;
	}
	
	.db_box b {
		color: #ff7200;
		margin-left: 8px;
	}
	
	.upbtn_box {
		text-align: center;
	}
	.textHf{margin: 0 auto;margin-top: 20px;color: #999;line-height: 30px;text-align: center;}
	.bottom_box{margin-bottom: 10px;}
</style>



// WEBPACK FOOTER //
// src/components/fac/Par.vue